import Dialog from '../ui-control/Dialog';
import XButton from '../common/XButton';

const wrapperClasses = 'p-6 text-center';
const iconWrapperClasses = 'mb-4';
const iconClasses = 'fas fa-file-invoice-dollar fa-3x text-primary';
const titleClasses = 'font-bold mb-2';
const descriptionClasses = 'text-body mb-6';
const priceClasses = 'font-bold text-content';
const actionsClasses = 'flex justify-center gap-4';

const CostProjectionPurchaseModal = ({ isOpen, isLoading, priceLabel, onConfirm, onCancel }) => {
    if (!isOpen) return null;

    return (
        <Dialog
            isModalOpen={isOpen}
            onToggleDialog={(isDialogOpen) => {
                if (!isDialogOpen) onCancel();
            }}
            mode="small-half"
            shouldNotShowButtons
        >
            <div className={wrapperClasses}>
                <div className={iconWrapperClasses}>
                    <i className={iconClasses} />
                </div>
                <h4 className={titleClasses}>Purchase Future Cost Projection</h4>
                <p className={descriptionClasses}>
                    You will be charged <span className={priceClasses}>{priceLabel}</span> to purchase and
                    download this cost projection.
                </p>
                <div className={actionsClasses}>
                    <XButton variant="outlinePrimary" onClick={onCancel} disabled={isLoading}>
                        Cancel
                    </XButton>
                    <XButton onClick={onConfirm} loading={isLoading} loadingText="Processing...">
                        Confirm and Download
                    </XButton>
                </div>
            </div>
        </Dialog>
    );
};

export default CostProjectionPurchaseModal;
